var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{attrs:{"as":"span"}},[_c('img',_vm._b({ref:"resizableImg",staticClass:"reader-img",attrs:{"data-drag-handle":_vm.isDraggable,"draggable":_vm.isDraggable,"alt":"image"}},'img',_vm.node.attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }